export default "__VITE_ASSET__Dimr9bSK__"